import { create } from "zustand";
import { nanoid } from "nanoid";

type ToastType = "success" | "warning" | "error" | "notice" | "delete";

interface Toast {
    id: string;
    type: ToastType;
    message?: string;
    onConfirmDelete?: () => void;
    onUndo?: () => void;
    timeoutId?: NodeJS.Timeout;
    height?: boolean;
}

interface ToastStore {
    toasts: Toast[];
    addToast: (toast: Omit<Toast, "id" | "timeoutId">) => void;
    dismissToast: (id: string) => void;
    undoToast: (id: string) => void;
}

const useToastStore = create<ToastStore>((set, get) => ({
    toasts: [],
    addToast: toast => {
        const id = nanoid();

        const timeoutId = setTimeout(() => {
            const currentToast = get().toasts.find(t => t.id === id);
            if (currentToast?.onConfirmDelete) currentToast.onConfirmDelete();
            get().dismissToast(id);
        }, 5000);

        set(state => ({
            toasts: [...state.toasts, { id, ...toast, timeoutId }],
        }));
    },
    dismissToast: id =>
        set(state => ({
            toasts: state.toasts.filter(toast => toast.id !== id),
        })),
    undoToast: id => {
        const toast = get().toasts.find(t => t.id === id);
        if (toast?.timeoutId) clearTimeout(toast.timeoutId);
        if (toast?.onUndo) toast.onUndo();
        get().dismissToast(id);
    },
}));

export default useToastStore;
